import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { forwardRefAndName } from "../../../../lib/forwardRefAndName";
import { BaseIcon } from "../../BaseIcon";
export var NetUploadIcon32Regular = forwardRefAndName('NetUploadIcon32Regular', function (props, ref) {
  return /*#__PURE__*/(
    React.createElement(BaseIcon, _extends({
      ref: ref,
      viewBoxSize: 32
    }, props), /*#__PURE__*/
    React.createElement("path", {
      d: "M7.66436 10.7475C7.25158 11.1144 6.61951 11.0772 6.25259 10.6644C5.88567 10.2516 5.92285 9.61956 6.33564 9.25264L13.3425 3.02428C14.8581 1.67713 17.1419 1.67713 18.6575 3.02428L25.6644 9.25264C26.0771 9.61956 26.1143 10.2516 25.7474 10.6644C25.3805 11.0772 24.7484 11.1144 24.3356 10.7475L17.3287 4.5191C17.2256 4.42744 17.1154 4.34826 17 4.28155V22.5001C17 23.0523 16.5523 23.5001 16 23.5001C15.4477 23.5001 15 23.0523 15 22.5001V4.28155C14.8846 4.34826 14.7744 4.42744 14.6713 4.5191L7.66436 10.7475Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      d: "M3.5 28.2501C3.5 27.6978 3.94772 27.2501 4.5 27.2501H27.5C28.0523 27.2501 28.5 27.6978 28.5 28.2501C28.5 28.8023 28.0523 29.2501 27.5 29.2501H4.5C3.94772 29.2501 3.5 28.8023 3.5 28.2501Z"
    }))
  );
});